import axios from "axios";
import { Modal, SelectorSearch } from "globalComponents";
import {
  Input,
  StyledForm,
  Title,
  Label,
  Textarea,
  SubmitButton,
  ButtonContent,
} from "globalComponents/FormComponents";
import LoadingIndicator from "globalComponents/LoadingIndicator";
import { errorHandler } from "globalResources/util";
import moment from "moment";
import { useState, useEffect } from "react";

const CreateReport = ({ onClose }) => {
  const [form, setForm] = useState({
    client: "",
    start: "",
    notes: "",
    daysBeforeDue: 7,
  });
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchClients = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/client/suggestions`)
      .then(async (res) => {
        if (res.data.length < 1) {
          setClients([]);
        } else {
          const clients = res.data;
          var temp = [];
          clients.forEach((client) => {
            if (client.name !== "All")
              temp.push({
                label: client.name,
                value: client._id,
                raw: client,
              });
          });
          setClients(temp);
        }
      })
      .catch((err) => this.setState({ loading: false, error: "error" }));
  };

  const onSubmit = async () => {
    setLoading(true);
    try {
      const selectedClient = clients.find(
        (client) => client.value === form.client,
      );
      const response = await axios.post(`/report`, {
        id: form.client,
        client: form.client,
        daysBeforeDue: form.daysBeforeDue,
        notes: form.notes,
        start: moment(form.start, "YYYY-MM-DD")
          .tz(selectedClient.raw.timezone)
          .startOf("day"),
      });
      onClose(response.data.report._id);
    } catch (error) {
      const { message, action } = errorHandler(error);
      console.error(error);
      alert(message);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <Modal width="550px" onClose={() => onClose()}>
      <StyledForm width="400px" margin="0 0 20px 0">
        <Title>Create Report</Title>
        <Label>Client</Label>
        <SelectorSearch
          options={clients}
          value={form.client}
          onSelect={(v) =>
            setForm({
              ...form,
              client: v,
              daysBeforeDue:
                clients.find((client) => client.value === v)?.raw
                  .defaultDaysBeforeDue || 7,
            })
          }
        />
        <Label>Start Date</Label>
        <Input
          type="date"
          value={form.start}
          onChange={(e) => setForm({ ...form, start: e.target.value })}
        />
        <Label tooltip="When billed, the number of days before marked past due">
          Days Due By
        </Label>
        <Input
          type="number"
          value={form.daysBeforeDue}
          onChange={(e) => setForm({ ...form, daysBeforeDue: e.target.value })}
        />
        <Label>Notes</Label>{" "}
        <Textarea
          value={form.notes}
          onChange={(e) => setForm({ ...form, notes: e.target.value })}
        />
        <SubmitButton onClick={onSubmit} disabled={loading}>
          {loading ? (
            <LoadingIndicator size="small" />
          ) : (
            <ButtonContent>Create</ButtonContent>
          )}
        </SubmitButton>
      </StyledForm>
    </Modal>
  );
};
export default CreateReport;
